export default "__VITE_ASSET__2054e8e8__"